export const deepClone = (obj: any): any => {
  if (obj === null || typeof obj !== 'object') {
    return obj
  }

  if (obj instanceof Function) {
    return obj
  }

  const clone: Record<string, any> = Array.isArray(obj) ? [] : {}

  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      clone[key] = deepClone(obj[key])
    }
  }

  return clone
}
